export default __webpack_public_path__ + "static/media/copy.4233c1b6.svg";